import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ArticleMetadata = ({ blog }) => {
  const [copied, setCopied] = useState(false);

  const handleShare = (platform) => {
    const url = window?.location?.href;
    const text = blog?.title;

    const shareUrls = {
      twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    };

    if (shareUrls?.[platform]) {
      window?.open(shareUrls?.[platform], '_blank', 'width=600,height=400');
    }
  };

  const handleCopyLink = async () => {
    try {
      await navigator?.clipboard?.writeText(window?.location?.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 py-4 mb-6 border-y border-border">
      <div className="flex items-center gap-4 text-sm text-muted-foreground">
        <div className="flex items-center gap-1.5">
          <Icon name="Eye" size={16} />
          <span>{blog?.popularity || 0} views</span>
        </div>
        {blog?.commentCount > 0 && (
          <div className="flex items-center gap-1.5">
            <Icon name="MessageCircle" size={16} />
            <span>{blog?.commentCount} comments</span>
          </div>
        )}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground mr-2">Share:</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => handleShare('twitter')}
          className="hover:text-accent"
        >
          <Icon name="Twitter" size={18} />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => handleShare('facebook')}
          className="hover:text-accent"
        >
          <Icon name="Facebook" size={18} />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => handleShare('linkedin')}
          className="hover:text-accent"
        >
          <Icon name="Linkedin" size={18} />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleCopyLink}
          className="hover:text-accent"
        >
          <Icon name={copied ? 'Check' : 'Link'} size={18} />
        </Button>
      </div>
    </div>
  );
};

export default ArticleMetadata;